import  {FC, useEffect, useMemo, useRef, useState} from 'react'
import {fetchData, formatNumber, toasterrormsg} from '../../../../reusable'
import {KTIcon} from '../../../../_metronic/helpers'
import {ToastContainer} from 'react-toastify'
import DataTable from 'react-data-table-component'
import Loader from '../../components/Loader'
import moment from 'moment'
import { Tr } from '../../../../_metronic/i18n/Tr'

const ViewCoupon: FC = () => {
  let t = Tr()
  
  const [couponList, setCouponList] = useState([])
  const [orgCouponList, setOrgCouponList] = useState([])

  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  
  //   Coupon list api call
  const couponListApiCall = async () => {
    setIsLoading(true)

    var res = await fetchData('admin/couponuseandcount', Object)

    if (res.status == '200') {
      setIsLoading(false)
      var data = res.data
      setCouponList(data)
      setOrgCouponList(data)
    } else {
      toasterrormsg(res.message)
    }
  }

  // search Coupon
  const couponSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setCouponList(orgCouponList)

    } else {
      var tmp: any = orgCouponList.filter((item: any) => {
        return (
          (item.en_offertitle != null &&
            item.en_offertitle != '' &&
            String(item.en_offertitle).toLowerCase().includes(text.toLowerCase())) ||
          (item.couponType != null &&
            item.couponType != '' &&
            String(item.couponType).toLowerCase().includes(text.toLowerCase())) ||
          (item.impact != null &&
            item.impact != '' &&
            String(item.impact).toLowerCase().includes(text.toLowerCase())) ||
          (item.couponValue != null &&
            item.couponValue != '' &&
            String(item.couponValue).toLowerCase().includes(text.toLowerCase()))
        )
      })


      setCouponList(tmp)
   
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Coupon')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
      </div>
    )
  }
  const formatDate2 = (date: any) => {
    return moment(date).format('DD-MM-YYYY')
  }

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Vendor Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.fullName !="" ? row.fullName : "-"}</div>
          </div>        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.fullName),
      },
      {
        name: t('Offer Title'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-6 d-flex align-items-center justify-content-center'>
              {/* <img
                className='w-50px h-50px me-2'
                src={
                  row.image.length > 0 ? row.image : toAbsoluteUrl('/media/logos/uztripLogo.png')
                }
                alt='images'
              /> */}
              <label className=''>{row.en_offertitle}</label>
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
        width: '200px',
      },
      {
        name: t('Coupon Code'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.couponCode !="" ? row.couponCode : "-"}</div>
          </div>        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.couponCode),
      },
      {
        name: t('Period'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.from !="" ? formatDate2(row.to): "-"}{" - "} {row.from !="" ? formatDate2(row.to): "-"}</div>
          </div>        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.from),
        width: '240px',

      },
      {
        name: t('Total Coupons'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.limitPerUser !=""  ? row.limitPerUser  : "-"}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.limitPerUser),
        filter: true,
        width: '200px',

      },
      {
        name: t('Used Coupons'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.couponcount !="" ? row.couponcount : "-" }</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.couponCount),
        filter: true,
        width: '200px',
        
      },
     
      {
        name: t('Used Coupon Values'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.impact !="" ? formatNumber(parseFloat(row.impact)) : "0 UZS" }</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.impact),
        filter: true,
        width: '200px',

      },
  
      {
        name: t('Coupon Value'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.couponType !="" ? row.couponType.toLowerCase() == "percentage" ? row.couponValue + "%" : formatNumber(row.couponValue) : ""}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.couponType),
        filter: true,
        width: '200px',

      },
    ],
    [t]
  )
  useEffect(() => {

    couponListApiCall()
    sessionStorage.removeItem('vendor')
    document.title = 'Insayr | View Coupons'
  }, [])

  return (
    <>
      <ToastContainer />
      {isLoading && <Loader />}
        <DataTable
          columns={column}
          data={couponList}
          pagination
          paginationServer={false}
          subHeader={true}
          subHeaderComponent={
            <CustomHeader search={searchTerm} isfoc={focus} customSearch={couponSearch} />
          }
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
        
          }}
        />
    
    </>
  )
}

export {ViewCoupon}
